export const seoKeywords = {
  name: 'keywords',
  content:
    'UX designers to hire, UI designers to hire, UX services, UX design company, UI services, user experience design services, design for web, design for mobile, prototyping services, wireframing services, figma designer',
};

export const uiuxSeo = {
  title: 'UX/UI Product Design Services for web and mobile apps | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Rumble Fish offers a full range of UI/UX services to help you build a creative, user-focused, and trustworthy brand that will stand out from the competition. From UX research to comprehensive product design - we’ve got you covered!',
    },
  ],
};
